import InboundTable from './InboundTable'

export default InboundTable
